import React from 'react';
import { Form } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
const AnswerTypeText = ({ data, qNo, onTextCheck, isReview }) => {
  return (
    <div className="w-100 spqAswerTypeText">
      <FloatingLabel controlId="floatingTextarea2" label={`${!isReview ? 'Type Your Answer' : ''}`}>
        <Form.Control
          readOnly={isReview}
          className="fs-4 p-4"
          as="textarea"
          placeholder="Answer"
          value={data?.textAnswer}
          onChange={(e) => {
            onTextCheck(e.target.value);
          }}
        />
      </FloatingLabel>
    </div>
  );
};

export default AnswerTypeText;
